import FileSaver from "file-saver";
import isMobileOrTabletDevice from "../common/isMobileOrTabletDevice";

export const downloadReceipt = async (url: string): Promise<void> => {
    // Warning: this check is needed because of Chrome and Firefox mobile's
    // browsers
    var isFileSaverSupported = !isMobileOrTabletDevice();
    if (isFileSaverSupported) {
        await FileSaver.saveAs(url, "application/pdf");
    } else {
        window.open(url, "_self");
    }
};
